module.exports = __webpack_public_path__ + "img/more_horiz_black_24dp.52882266.svg";